var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-fill",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165994",
    "data-name": "Path 165994",
    d: "M14,7A7,7,0,1,1,7,0a7,7,0,0,1,7,7ZM10.526,4.349a.656.656,0,0,0-.945.019L6.542,8.24,4.711,6.408a.656.656,0,0,0-.928.928L6.1,9.651a.656.656,0,0,0,.944-.018l3.493-4.366a.656.656,0,0,0-.009-.919Z",
    fill: "none",
    stroke: "#b1b3b3",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFill);
export default __webpack_public_path__ + "static/media/check-circle-fill.548eacd380a8af5e2f47a5e9c46b12f7.svg";
export { ForwardRef as ReactComponent };